<!--
 * @Author: your name
 * @Date: 2021-11-22 10:12:52
 * @LastEditTime: 2021-11-26 16:28:01
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/layout/Nav.vue
-->
<template>
  <div class="header-nav">
    <el-row type='flex' justify='space-between' class="nav-wrapper" align='middle'>
      <el-row type='flex' align='middle'>
        <el-image :src='require("@/assets/common/logo.png")' class="text-info-link" @click="onJumpIndex"></el-image>
        <slot>
          <el-menu :default-active="activeType" mode="horizontal" @select='onSelectType'>
            <el-menu-item index='1'>渠道分类</el-menu-item>
            <el-menu-item index='2'>科室分类</el-menu-item>
            <el-menu-item index='3'>地区分类</el-menu-item>
            <el-drawer
              :visible.sync="showDrawer"
              class='drawer-wrapper'
              :withHeader='false'
              :modal='false'
              direction='ttb'
              :show-close='false'
            >
              <div class="wrapper-content" v-if="activeType === '1'">
                <div class="check-item" :class="{active: activeNav === item.value}" v-for="item in channelList" :key='item.value' @click="onJumpSearch(item, 'channel')">{{item.name}}</div>
              </div>
              <div class="wrapper-content" v-if="activeType === '2'">
                <div class="check-item" :class="{active: activeNav === item.value}" v-for="item in departmentList" :key='item.value' @click="onJumpSearch(item, 'department')">{{item.name}}</div>
              </div>
              <div class="wrapper-content" v-if="activeType === '3'">
                <div class="check-item" :class="{active: activeNav === item.id}" v-for="item in areaList" :key='item.id' @click="onJumpSearch(item, 'area')">{{item.name}}</div>
              </div>
            </el-drawer>
          </el-menu>
        </slot>
      </el-row>
      <slot name="fix">
        <div class="search-wrapper">
          <el-input prefix-icon="el-icon-search" placeholder='搜索热门产品' v-model="searchText" @change='onSearch'></el-input>
        </div>
      </slot>
    </el-row>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  name: 'Nav',
  data () {
    return {
      activeType: '',
      searchText: '',
      activeNav: '',
      showDrawer: false,
    }
  },
  props: {
    searchTxt: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['channelList', 'departmentList','areaList'])
  },
  watch: {
    showDrawer (show) {
      if (show) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'visible'
      }
    },
     searchTxt (val) {
       if (val) {
         this.searchText = val
       }
     }
  },
  methods: {
    onSelectType (key) {
      this.activeType = key
      this.showDrawer = true
    },
    onJumpSearch (item, type) {
      switch (type) {
        case 'channel':
          this.activeNav = item.value
          window.open(`/demand/list?channelId=${item.value}&channelName=${item.name}`)
          break
        case 'department':
          this.activeNav = item.value
          window.open(`/demand/list?departmentId=${item.value}&departmentName=${item.name}`)
          break
        case 'area':
          this.activeNav = item.id
          window.open(`/demand/list?areaId=${item.id}&areaName=${item.name}`)
          break            
      }
    },
    onSearch () {
      if (this.$route.name === 'DemandList') {
        this.$emit('onSearch', this.searchText);
      } else {
        window.open(`/demand/list?searchText=${this.searchText}`)
      }
    },
    onJumpIndex () {
      this.$router.push('/index')
    }
  },
  mounted () {
    console.log(this.searchTxt)
    this.searchText = this.searchTxt
  },
  destroyed () {
    document.body.style.overflow = 'visible'
  }
}
</script>
<style lang="scss" scoped>
  .header-nav ::v-deep {
    max-width: 1920px;
    background-color: #fff;
    display: flex;
    align-items: center;
    height: 60px;
    .el-menu.el-menu--horizontal {
      border: none;
      margin-left: 35px;
      .el-menu-item {
        color: #0F0F0F;
        padding: 0;
        margin-right: 50px;
      }
    }
    .el-menu--horizontal > .el-menu-item.is-active {
      border-bottom: 4px solid;
      color: #5259D6;
    }
    .el-drawer__wrapper {
      top: 92px;
    }
  }
  .nav-wrapper {
    max-width: 1280px;
    margin: 0 auto;
    flex: 1;
  }
  .search-wrapper ::v-deep {
    width: 220px;
    .el-input__inner {
      border-radius: 30px;
      background-color: #FAFAFA;
    };
  }
  .wrapper-content {
    margin: 0 auto;
    max-width: 1280px;
    padding-top: 30px;
    display: flex;
    flex-wrap: wrap;
    .check-item {
      width: 12%;
      height: 40px;
      line-height: 40px;
      color: #0F0F0F;
      cursor: pointer;
      text-align: center;
      &:hover,&.active {
        background-color: #F6F7FB;
        color: #5259D6;
      }
    }
  }
</style>